/*получение timezone пользователя в нужном формате*/
function complainGetTimezone() {
    const date = new Date();
    const formattedDate = date.toLocaleString('ru-RU').replace(',', '');
    const timeZoneInfo = date.toString().match(/GMT[^)]+\)/)[0];
    return formattedDate + ' ' + timeZoneInfo;
}
/*обработка при вводе в input поле*/
$('#complainFIO, #complainPhone, #complainBirthDate, #complainEmail, #complainDescription, #complainContractNum').on('input', function() {
    if ( $(this).val().length > 0 ) {
        $(this).parent().find('.form-label').hide();
    } else {
        $(this).parent().find('.form-label').show();
    }

    complainHideValidationFeedback($(this));
});

/*Валидация input полей ::Start::*/
function complainValidationForm() {
    let isValis = true;
    const fioValid = complainFIOValidation($('#complainFIO').val());
    const phoneValid = complainPhoneValidation($('#complainPhone').val());
    const birthDateValid = complainBirthDateValidation($('#complainBirthDate').val());
    const mailValid = complainMailValidation($('#complainEmail').val());
    const themeValid = complainThemeValidation($('#complainTheme').val());
    const descriptionValid = complainDescriptionValidation($('#complainDescription').val());

    if ( !fioValid.valid ) {
        isValis = false;
        complainShowValidationFeedback($('#complainFIO'), fioValid.description);
    }
    if ( !phoneValid.valid ) {
        isValis = false;
        complainShowValidationFeedback($('#complainPhone'), phoneValid.description);
    }
    if ( !birthDateValid.valid ) {
        isValis = false;
        complainShowValidationFeedback($('#complainBirthDate'), birthDateValid.description);
    }
    if ( !mailValid.valid ) {
        isValis = false;
        complainShowValidationFeedback($('#complainEmail'), mailValid.description);
    }
    if ( !themeValid.valid ) {
        isValis = false;
        complainShowValidationFeedback($('#complainTheme'), themeValid.description);
    }
    if ( !descriptionValid.valid ) {
        isValis = false;
        complainShowValidationFeedback($('#complainDescription'), descriptionValid.description);
    }

    return isValis;
}

function complainShowValidationFeedback(elem, description) {
    elem.addClass('invalid-input-custom');
    elem.parent().find('.invalid-feedback').addClass('show-alert-custom');
    elem.parent().find('.invalid-feedback').text(description);
}

function complainHideValidationFeedback(elem) {
    elem.removeClass('invalid-input-custom');
    elem.parent().find('.invalid-feedback').removeClass('show-alert-custom');
}

function complainFIOValidation(str) {
    const result = {valid: true, description: ''};
    const regex = /^[А-Яа-яЁё\s\-]+$/;
    
    if ( str.length < 1 ) {
        result.valid = false;
        result.description = 'Это поле необходимо заполнить';
        return result;
    }

    if ( !regex.test(str) ) {
        result.valid = false;
        result.description = 'Это поле должно содержать только русские буквы';
        return result;
    }

    return result;
}

function complainPhoneValidation(str) {
    const result = {valid: true, description: ''};
    const regex = /^\+7\s\(\d{3}\)\s\d{3}-\d{2}-\d{2}$/;

    if ( str.length < 18 ) {
        result.valid = false;
        result.description = 'Это поле необходимо заполнить';
        return result;
    }

    if ( !regex.test(str) ) {
        result.valid = false;
        result.description = 'Номер телефона введён не верно';
        return result;
    }

    return result;
}

function complainBirthDateValidation(str) {
    const result = {valid: true, description: ''};

    if ( str.length < 10 ) {
        result.valid = false;
        result.description = 'Это поле необходимо заполнить';
        return result;
    }
    
    const formatedValue = dayjs(str,'DD.MM.YYYY', 'ru', true);
    if ( !formatedValue.isValid() ) {
        result.valid = false;
        result.description = 'Не верный формат даты';
        return result;
    }

    const diff = dayjs().diff(formatedValue, 'year', true);
    if ( diff <= 18.42 || diff > 110.42 ) {
        result.valid = false;
        result.description = 'Некорректная дата рождения';
        return result;
    }

    return result;
}

function complainMailValidation(str) {
    const result = {valid: true, description: ''};
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if ( str.length == 0 ) {
        result.valid = false;
        result.description = 'Это поле необходимо заполнить';
        return result;
    }

    if ( !regex.test(str) ) {
        result.valid = false;
        result.description = "Не верный формат e-mail'a";
        return result;
    }

    return result;
}

function complainThemeValidation(str) {
    const result = {valid: true, description: ''};

    if ( str.length == 0 ) {
        result.valid = false;
        result.description = 'Тема не выбрана';
        return result;
    }

    return result;
}

function complainDescriptionValidation(str) {
    const result = {valid: true, description: ''};

    if ( str.length < 10 ) {
        result.valid = false;
        result.description = 'Это поле необходимо заполнить';
        return result;
    }

    return result;
}
/*Валидация input полей ::End::*/

/*Логика обработки select темы жалобы ::Start::*/
$('#complainThemeSelectBut').on('click', function() {
    $('.complain-form-select__options').toggle();

    if ( $('#complainTheme').val().length > 0 ) {
        $('#complainThemeSelectBut').find('.form-label').hide();
    } else {
        $('#complainThemeSelectBut').find('.form-label').show();
    }

    complainHideValidationFeedback($('#complainTheme'));
});

$('.options-item').on('click', function() {
    $('#complainTheme').val($(this).text());
    $('#complainTheme').removeClass('invalid-input-custom');
    $('.complain-form-select__options').hide();
    $('#complainThemeSelectBut').find('.form-label').hide();
});
/*Логика обработки select темы жалобы ::End::*/

/*загрузка изображений и файлов ::Start::*/
const complainMaxFiles = 4;
const complainMaxSize = 5 * 1024 * 1024;//ограничение в размере 5мб
let complainSelectedFiles = [];

// Обработка выбора файлов
$('#complainImgInput').on('change', function(e) {
    const files = e.target.files;
    const formatTypes = ['image/png', 'image/jpeg', 'image/jpg', 'application/pdf'];

    $(this).parent().find('.invalid-feedback').removeClass('show-alert-custom');
    $(this).parent().find('.invalid-feedback').text('');
    
    if ( complainSelectedFiles.length + files.length > complainMaxFiles ) {
        $(this).parent().find('.invalid-feedback').addClass('show-alert-custom');
        $(this).parent().find('.invalid-feedback').text(`Можно загрузить не более ${complainMaxFiles} фотографий`);
        $(this).val('');
        return;
    }

    for (let i = 0; i < files.length; i++) {
        let error = false;
        let errorMessage = '';

        if ( !formatTypes.includes(files[i].type) ) {
            error = true;
            errorMessage = 'Не верный формат файла';
        }
        
        if ( files[i].size > complainMaxSize ) {
            error = true;
            errorMessage = 'Размер файла не должен превышать 5MB';
        }

        if (error) {
            $(this).parent().find('.invalid-feedback').addClass('show-alert-custom');
            $(this).parent().find('.invalid-feedback').text(errorMessage);
            $(this).val('');
            return;
        }
        
        complainSelectedFiles.push(files[i]);
    }

    createImgPreview();
    $(this).val('');
});

function createImgPreview() {
    const imgLoadedContainer = $('.img-loaded-items');
    imgLoadedContainer.empty();

    complainSelectedFiles.forEach(function(element, index) {
        // Создаем элемент превью загруженного файла
        const previewItem = $(
            `<div class="img-loaded-item">
                <span class="img-loaded-item-name">${element.name}</span>
                <div class="img-loaded-item-close-but" data-index="${index}">
                    <img src="${imgLoadedContainer.attr('data-close-img-path')}" alt="">
                </div>
            </div>`
        );

        previewItem.find('.img-loaded-item-close-but').on('click', function() {
            complainSelectedFiles.splice($(this).attr('data-index'), 1);
            createImgPreview();
        });

        imgLoadedContainer.append(previewItem);
    });
}
/*загрузка изображений и файлов ::End::*/

/*Разблокируем кнопку отправки формы с помощью input checkbox */
$('#complainAgreement').change(function() {
    if ( $(this).is(':checked') ) {
        $('#complainButSubmit').removeClass('disable-but');
    } else {
        $('#complainButSubmit').addClass('disable-but');
    }
});

/*Сбрасываем форму*/
function complainResetForm() {
    $('#complainRequestForm').find('.form-label').show();
    $('.img-loaded-items').empty();
    complainSelectedFiles = [];
    $('#complainButSubmit').addClass('disable-but');
}

/*ajax отправка формы жалобы*/
function sendComplainAjaxForm() {
    const serializedData = $('#complainRequestForm').serialize();
    const formData = new FormData();

    if ( complainSelectedFiles.length > 0 ) {
        complainSelectedFiles.forEach((file) => {
            formData.append('files[]', file);
        });
    }

    formData.append('timezone', complainGetTimezone());

    serializedData.split('&').forEach(pair => {
        const parts = pair.split('=');
        const key = decodeURIComponent(parts[0]);
        const value = decodeURIComponent(parts[1] || '');
        formData.append(key, value);
    });
        
    $('#complainButSubmit').addClass('disable-but');
    const loader = Actions.showLoader('requestLoader');

	$.ajax({
		url: `${ajaxData.url}?action=complain_form`,
		type: "POST",
		data: formData,
        processData: false,
        contentType: false,
		success: function(response) {
            Actions.hideLoader(loader);
            Actions.showModal('complainModal');
            $('#complainRequestForm')[0].reset();
            complainResetForm();
            $('#complainButSubmit').removeClass('disable-but');

            if ( response.error ) {
                $('#complainModal').find('.success-content').addClass('d-none');
                $('#complainModal').find('.error-content').removeClass('d-none');
            } else {
                $('#complainModal').find('.success-content').removeClass('d-none');
                $('#complainModal').find('.error-content').addClass('d-none');
            }
		}
	});
}

$(document).ready( function () {
    $('#complainPhone').mask('+7 (ZZZ) ZZZ-ZZ-ZZ', {//предустановка маски
        translation: {
          Z: {pattern: /[0-9]/}
        },
        placeholder: ''
    })
    $('#complainBirthDate').mask('99.99.9999', {//предустановка маски
        translation: {
          Z: {pattern: /[0-9]/}
        },
        placeholder: ''
    })

    $('#complainButSubmit').off('click');
    $('#complainButSubmit').on('click', function(event) {
        event.preventDefault();

        if ( $(this).hasClass('disable-but') ) {
            return;
        }

        if ( complainValidationForm() ) {
            sendComplainAjaxForm();
        }
    });
});